import { FormFieldGroup, FormInput, FormLabel } from '$components'
import { Input } from './index'

export function EditVeterinaryInformationContent() {
  return (
    <div className="flex flex-col gap-6 flex-grow">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.VetName}>
          Veterinarian
        </FormLabel>
        <FormInput
          name={Input.VetName}
          placeholder="Enter veterinarian name..."
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.VetPhone}>
          Contact Number
        </FormLabel>
        <FormInput
          name={Input.VetPhone}
          placeholder="Enter contact number..."
        />
      </FormFieldGroup>
    </div>
  )
}
